module.exports = __webpack_public_path__ + "media/answer_incorrect.a406327a.mp3";